import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayProfessionalSkillsRatingSelectedPayload {
  shiftId: string;
  rating: number;
}

/**
 * Fires when an office adjusts the professional skills star rating on the
 * end-of-day review page.
 * Event: dental_portal:end_of_day:professional_skills_rating_selected
 */
export function fireEndOfDayProfessionalSkillsRatingSelected(
  payload: IEndOfDayProfessionalSkillsRatingSelectedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:end_of_day:professional_skills_rating_selected',
    {
      shift_id: payload.shiftId,
      rating: payload.rating,
    },
  );
}
